import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import Header from '../../components/Header in Page/_Header';
import NewHeader from '../../components/New Header/NewHeader'
import { getContractTable } from '../../features/gasSlice';

function NuovoContratto() {
    const [overlay, setOverlay] = useState(false);
    const tableDescription = useSelector(getContractTable)
  return (
    <div className="letture">
      <div className="letture-top">
        <NewHeader
          logo="white"
          padding="no"
          iconsColor="white"
          overlay={overlay}
          overlayTitle="Indietro"
          setOverlay={setOverlay}
        />
        </div>
    
        <div className="letture-bottom">
            
        <Header
            title="Rinnovo Contrattuale"
            description={tableDescription}
          />
        </div>  
    </div>
  )
}

export default NuovoContratto